import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
// Observable class extensions
import 'rxjs/add/observable/of';
// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { LoggingService } from '../../services/services';

@Component({
    selector: 'products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.css']
})

export class ProductsComponent implements OnInit {
    private searchTerms = new Subject<string>();
    // TODO: Seems like a hacky way to replay the same search when switching clients.
    private _lastSearchTerm: string = '';
    isError: boolean;
    isSuccess: boolean;
    isWorking: boolean;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private loggingService: LoggingService
    ) {
        if (loggingService) {
            loggingService.logPageView("Products");
        }
    }

    ngOnInit(): void {

        // TODO: This seems kind of hacky and not how Observables should have to work.
        this.searchTerms.debounceTime(300).subscribe(term => {
            this._lastSearchTerm = term;
            this.isWorking = false;
        });
    }

    search(term: string) {
        this.searchTerms.next(term);
        this.searchTerms.subscribe(value => {
            this._lastSearchTerm = value;
        });
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/src/app/components/products/products.component.ts